import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription } from 'rxjs';
import { IClientModel } from 'src/app/core/models/application.model';
import {
  IBackgroundModel,
  IBackgroundFile,
} from 'src/app/core/models/background.model';
import { IUser } from 'src/app/core/models/user.model';
import { ApplicationService } from 'src/app/core/services/application.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ClientService } from 'src/app/core/services/client.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { sharedDataService } from 'src/app/core/services/sharedData.service';
import {
  bgTypeOptions,
  blurOptions,
  cropOptions,
  logoPositionOptions,
  interiorCropOptions,
  cameraLibelaSensitivity,
  shadowType,
} from 'src/app/core/const/settings';

@Component({
  selector: 'app-subcustomer-users',
  templateUrl: './subcustomer-users.component.html',
  styleUrls: ['./subcustomer-users.component.css'],
})
export class SubcustomerUsersComponent implements OnInit {
  constructor(
    private customerService: CustomerService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private router: Router,
    private sharedData: sharedDataService,
    private authService: AuthService,
    private applicationService: ApplicationService,
    private route: ActivatedRoute,
    private clientService: ClientService,
    private fb: FormBuilder
  ) {}

  @ViewChild('dialogDefaultBg') public dialogDefaultBg: TemplateRef<any>;
  @ViewChild('dialogDefaultLogo') public dialogDefaultLogo: TemplateRef<any>;
  @ViewChild('dialogDefaultPlate') public dialogDefaultPlate: TemplateRef<any>;

  cropOptions = cropOptions;
  bgTypeOptions = bgTypeOptions;
  cameraLibelaSensitivity = cameraLibelaSensitivity;
  logoPositionOptions = logoPositionOptions;
  blurOptions = blurOptions;
  interiorCropOptions = interiorCropOptions;
  shadowType = shadowType;

  applications: IClientModel[];
  applicationsDataSearch: IClientModel[];
  applicationsAll: IClientModel[] = [];
  selectedApp: IClientModel = null;
  searchParamApp: string;

  users: IUser[];
  currentUser: IUser;

  userToAddCredit: IUser;
  modalAddUserCredit;

  searchParam = '';
  usersDataSearch: IUser[] = [];

  page = 1;
  perPage = 16;
  clientPage = 1;
  clientPerPage = 12;
  adminPage = 1;
  adminPerPage = 3;

  toggleAddUser = false;
  toggleAddClient = false;
  toggleNewClient = false;
  toggleDmsModal = false;

  customerId: string;
  @Input() customer;
  clientID: string;
  @Output() credit = new EventEmitter();

  newBackgrounds: IBackgroundModel[];
  backgroundFiles: IBackgroundFile[] = [];

  canSeeAdmins: boolean;

  licensePlates;
  licensePlateModal;
  featuresNames;
  logoModal;
  clientFeatures;
  toggleFeaturePrice = false;
  private eventsSubscription: Subscription;
  @Input() loadData: Observable<void>;
  @Input() removeReflections: Observable<void>;
  presetsList: any = [];

  toggleChangeInvoice: boolean;
  toggleSSHSetup: boolean = false;
  toggleAddSSH = false;
  toggleDeleteSSH = false;
  isLoadingSSHKeys = false;
  sshKeys = [];
  sshKey = null;
  sshForm: FormGroup;

  invoiceFields = [
    {
      name: 'id',
      labelName: 'id',
    },
    {
      name: 'timestamp',
      labelName: 'timestamp',
    },
    {
      name: 'invoiceNumber',
      labelName: 'invoiceNumber',
    },
    {
      name: 'email',
      labelName: 'email',
    },
    {
      name: 'type',
      labelName: 'type',
    },
    {
      name: 'vin',
      labelName: 'vin',
    },
    {
      name: 'price',
      labelName: 'price',
    },
    {
      name: 'description',
      labelName: 'description',
    },
    {
      name: 'itemAdditionalInfo',
      labelName: 'itemAdditionalInfo',
    },
    {
      name: 'additionalInfo',
      labelName: 'additionalInfo',
    },
    {
      name: 'imagesCount',
      labelName: 'imagesCount',
    },
    {
      name: 'features',
      labelName: 'features',
    },
    {
      name: 'vehicles',
      labelName: 'vehicles',
    },
    {
      name: 'brand',
      labelName: 'brand',
    },
    {
      name: 'multiPictureIn',
      labelName: 'multiPictureIn',
    },
    {
      name: 'multiPictureOut',
      labelName: 'multiPictureOut',
    },
    {
      name: 'condition',
      labelName: 'Condition',
    },
    {
      name: 'licensePlateNumber',
      labelName: 'License Plate Number',
    },
  ];

  ngOnInit(): void {
    this.translate
      .get([
        'features.cutting',
        'features.licensePlateImage',
        'features.reflectiveFloor',
        'features.polishing',
        'features.rimPolishing',
        'features.licensePlateBlur',
        'features.refectiveFloorFull',
        'features.removeReflections',
        'features.platform_360',
      ])
      .subscribe((values) => {
        this.featuresNames = values;
        this.featuresNames = Object.entries(values);
      });

    this.translate
      .get(['global.loading', 'user.selectPreset', 'user.selectBackgrounds'])
      .subscribe((values) => {
        const translation = Object.keys(values).map((key) => values[key]);
      });

    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });

    this.route.params.subscribe((params: Params) => {
      this.customerId = params.customerId || this.currentUser.customerId;
      // this.loadClients(this.customerId);
    });

    this.route.queryParams.subscribe((queryParams: Params) => {
      this.page = queryParams.page ? queryParams.page : 1;
      this.clientID = queryParams.clientId ? queryParams.clientId : null;
      this.searchParam = queryParams.searchParam ? queryParams.searchParam : '';
      this.loadClients(this.customerId);
    });

    /*  this.eventsSubscription = this.loadData.subscribe(() => {
      this.selectedApp ? this.initializeBackgroundsAndPresets() : null;
    });*/

    this.eventsSubscription = this.removeReflections.subscribe(() => {
      this.selectedApp ? this.loadClient() : null;
    });

    // const app = this.sharedData.appId;

    // if (app) {
    //   this.selectedApp = app;
    //   const page = this.sharedData.userPage;
    //   if (page) {
    //     this.page = page;
    //   }

    //   const userSearch = this.sharedData.userSearch;
    //   if (userSearch) {
    //     this.searchParam = userSearch;
    //   }
    //   this.showUsersAfterReload(this.selectedApp);
    // }

    this.loadCustomerSettings();
  }

  customerSettings: any = null;
  loadCustomerSettings() {
    this.customerService
      .getCustomerSettings(this.customerId)
      .subscribe(
        (res) => {
          this.customerSettings = res;
        },
        (err) => {}
      );
  }

  reloadClient(clientID: string) {
    const client = this.applications.find(
      (client) => client.id === this.clientID
    );
    if (client) {
      this.showUsersAfterReload(client);
    }
  }

  loadClients(customerId: string) {
    this.customerService
      .getApplications(this.customerId)
      .subscribe((res: IClientModel[]) => {
        this.applications = res;
        this.applicationsDataSearch = this.applications;
        this.applicationsAll = res;
        if (this.clientID) {
          this.reloadClient(this.clientID);
        }
      });
  }

  searchClients(searchFields) {
    this.page = 1;
    this.customerService
      .getApplications(this.customerId, searchFields)
      .subscribe((res: IClientModel[]) => {
        this.applications = res;
        this.applicationsDataSearch = this.applications;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { clientId: null },
          queryParamsHandling: 'merge',
        });
      });
  }

  showUsers(application: IClientModel) {
    this.isLoading = true;
    this.selectedApp = application;
    this.page = 1;
    this.searchParam = '';

    this.loadClient();
    this.clientID = this.selectedApp.id;
    this.changeQuery({
      clientId: this.clientID,
      searchParam: null,
      page: null,
    });
    const element = document.getElementById('target');
    const yOffset = 130;
    element.style.minHeight = '85vh';
    const y =
      element.getBoundingClientRect().top + window.pageYOffset - yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  showUsersAfterReload(application: IClientModel) {
    this.selectedApp = application;
    this.loadClient();
  }

  loadClient() {
    this.applicationService.getById(this.selectedApp.id).subscribe(
      (res) => {
        this.selectedApp = res;
        this.sharedData.appId = this.selectedApp;

        if (this.applications.length) {
          const index = this.applications.findIndex(
            (client) => client.id === res.id
          );
          this.applications[index] = res;

          const index1 = this.applicationsDataSearch.findIndex(
            (client) => client.id === res.id
          );
          if (index1 !== -1) {
            this.applicationsDataSearch[index] = res;
          }
        }
        this.isLoading = false;
      },
      (err) => {}
    );
  }

  client = {} as IClientModel;
  onEditClient(client: IClientModel) {
    this.client = client;
    this.client.isNew = false;
    this.logoFile = null;
    this.previewImage = this.client.logo
      ? this.client.logo.thumbnailPath
      : null;
    this.toggleAddClient = true;
  }

  onAddClient() {
    this.client.isNew = true;
    this.toggleAddClient = true;
    this.previewImage = null;
    this.logoFile = null;
    this.client.paymentType = 'prepaid';
  }

  /* sendUserCredit(form: NgForm) {
    if (!form.form.value.credit) {
      this.translate.get('customer.creditError').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    if (form.form.value.credit < 1) {
      const credit = -form.form.value.credit;
      if (credit > +this.userToAddCredit.client.credits) {
        this.toastr.error(
          `You can enter credit up to ${this.userToAddCredit.client.credits}`
        );
        return;
      }
    }

    this.userService
      .transferCredit(
        this.userToAddCredit.id,
        form.form.value.credit,
        this.userToAddCredit.clientId
      )
      .subscribe(
        (response) => {
          this.translate.get('customer.creditAdd').subscribe((text: string) => {
            this.toastr.success(text);
          });
          this.modalAddUserCredit.close();

          console.log('credit', response);

          const user = this.usersDataSearch.find(
            (user) => user.id === response.userId
          );

          if (user !== undefined) {
            // ! credit
            user.client = response;
            this.selectedUser = user;
          }

          this.loadClient();
          // this.setCustomerCredit(form.form.value.credit);
          // this.onChangeCredit(form.form.value.credit);
        },
        (error) => {
          this.toastr.error(error.message);
          this.modalAddUserCredit.close();
        }
      );
  }*/

  onChangeCredit(credit: number) {
    this.credit.emit(credit);
  }

  isLoading = false;
  sendApplication(form: NgForm) {
    if (!form.valid) {
      this.translate.get('errors.missingData').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }
    let body = new FormData();

    Object.keys(form.form.value).forEach((key) => {
      if (form.form.value[key] !== undefined) {
        body.append(key, form.form.value[key]);
      }
    });

    if (this.logoFile) {
      body.append('logo', this.logoFile);
    }

    this.isLoading = true;
    this.toggleAddClient = false;

    this.applicationService
      .addClientAsCustomer(body, this.customerId)
      .subscribe(
        (response: IClientModel) => {
          this.toastr.success(`Client ${response.name} added.`);
          this.loadClients(this.customerId);
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.translate.get('errors.errorCreatingClient').subscribe((text: string) => {
            this.toastr.error(text);
          });
        }
      );
  }

  editClient(form: NgForm) {
    if (!form.valid) {
      this.translate.get('errors.missingData').subscribe((text: string) => {
            this.toastr.error(text);
          });
      return;
    }

    const editData = form.form.value;

    const body = new FormData();

    Object.keys(this.client).forEach((key) => {
      if (key in editData) {
        if (this.client[key] !== editData[key]) {
          body.append(key, editData[key] === '' ? null : editData[key]);
        }
      }
    });

    if (this.logoFile) {
      body.append('logo', this.logoFile);
    }

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      return;
    }

    this.applicationService.updateClient(this.client.id, body).subscribe(
      (response: IClientModel) => {
        this.toastr.success(`Client ${response.name} updated.`);
        this.loadClients(this.customerId);
        this.toggleAddClient = false;
      },
      (error) => {
        this.translate.get('errors.errorUpdatingClient').subscribe((text: string) => {
          this.toastr.error(text);
        });
      }
    );
  }

  jumpToClientPage(event: any) {
    this.clientPage = event;

    // this.sharedData.userPage = this.page;
    // this.page == 1 ? this.changeQuery({ 'page': null }) : this.changeQuery({ 'page': this.page });
  }

  previewImage = null;
  licensePlateFile = null;
  logoFile = null;
  toggleAddLicensePlate = false;

  fileSelectorOpen() {
    const element: HTMLElement = document.getElementById(
      `logoFile`
    ) as HTMLElement;
    element.click();
  }

  getFile(event) {
    this.logoFile = event.target.files[0];
    if (!this.logoFile.type.match('image.*')) {
      return this.translate.get('errors.pleaseUploadImage').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
    this.readURL(this.logoFile);
  }

  readURL(image) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.previewImage = reader.result;
      },
      false
    );
    if (image) {
      reader.readAsDataURL(image);
    }
  }

  toggleChangeCustomer = false;
  customers = [];
  showCustomers = false;
  searchCustomersParam = '';
  customersSearch = [];
  selectedCustomer = null;
  onChangeCustomer(client) {
    this.toggleChangeCustomer = true;
    this.client = client;
    console.log('ovooo')
    if (this.currentUser.role.name === 'customer') {
      this.customerService.get(this.currentUser.customerId)
       .subscribe(
         res => {
           this.customers = this.flattenCustomers(res);
         },
         err => { }
       );
    } else {
      this.customerService.getAll().subscribe(
        (res) => {
          this.customers = res;
        },
        (err) => {}
      );
    }

  }

  private flattenCustomers(root) {
    const result = [ root ];

    if (root.customers && root.customers.length) {
      for (const child of root.customers) {
        // recurse into each child, and append all of their descendants
        result.push(...this.flattenCustomers(child));
      }
    }

    return result;
  }

  openCustomers() {
    this.showCustomers = !this.showCustomers;
    this.searchCustomersParam = '';
    this.customersSearch = this.customers;
  }

  applyCustomerFilter() {
    this.customersSearch = [];

    this.customersSearch = this.customers.filter(
      (customer) =>
        customer.name
          .toLowerCase()
          .indexOf(this.searchCustomersParam.toLowerCase()) !== -1
    );
  }

  selectCustomer(customer) {
    this.selectedCustomer = customer;
  }

  onCloseCustomer() {
    this.toggleChangeCustomer = false;
    this.selectedCustomer = null;
  }

  moveClient() {
    if (!this.selectedCustomer) {
      return;
    }

    let body = {
      toCustomerId: this.selectedCustomer.id,
    };

    this.clientService.changeCustomer(this.client.id, body).subscribe(
      (res) => {
        this.toastr.success('Client transfered.');

        const client = this.applications.find(
          (client) => client.id === this.client.id
        );

        if (client) {
          if (this.applications.indexOf(client) !== -1) {
            this.applications.splice(this.applications.indexOf(client), 1);
          }

          if (this.applicationsDataSearch.indexOf(client) !== -1) {
            this.applicationsDataSearch.splice(
              this.applicationsDataSearch.indexOf(client),
              1
            );
          }
        }

        this.client = null;
        this.toggleChangeCustomer = false;
      },
      (err) => {
        this.client = null;
        this.toggleChangeCustomer = false;
        this.toastr.error(err.error.description);
      }
    );
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  changeQuery(data) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: data,
      queryParamsHandling: 'merge',
    });
  }

  onInvoiceConfig(client: IClientModel) {
    this.client = client;
    this.toggleChangeInvoice = true;
  }

  onSshSetup(client) {
    this.client = client;
    this.toggleSSHSetup = true;
    this.isLoadingSSHKeys = true;

    this.clientService.getClientSHHKeys(client.id).subscribe(
      (res) => {
        this.sshKeys = res;
        this.isLoadingSSHKeys = false;
      },
      (err) => {
        this.isLoadingSSHKeys = false;
      }
    );
  }

  onAddSSH() {
    this.toggleAddSSH = true;
    this.initializeSSHForm();
  }

  initializeSSHForm() {
    this.sshForm = this.fb.group({
      name: ['', Validators.required],
      type: ['ed25519', Validators.required],
    });
  }

  onDeleteSSH(key) {
    this.sshKey = key;
    this.toggleDeleteSSH = true;
  }

  deleteSSHKey() {
    this.clientService
      .deleteClientSHHKey(this.client.id, this.sshKey.id)
      .subscribe(
        (res) => {
          this.sshKeys = this.sshKeys.filter(
            (key) => key.id !== this.sshKey.id
          );

          this.toggleDeleteSSH = false;
          this.sshKey = null;
        },
        (err) => {}
      );
  }

  onSubmit() {
    let { name, type } = this.sshForm.value;
    let body = { name, type };

    this.addSSHKey(body);
  }

  addSSHKey(body) {
    this.clientService.createClientSHHKey(this.client.id, body).subscribe(
      (res) => {
        this.sshKeys.push(res);
        this.sshForm.reset();

        this.toggleAddSSH = false;
      },
      (err) => {
        this.toastr.error(err.message);
      }
    );
  }

  toggleSSHPublicKey = false;
  publicKey = null;
  isLoadingSSH = false;
  seeSSHPublicKey(keyId: string) {
    this.toggleSSHPublicKey = true;
    this.isLoadingSSH = true;

    this.clientService.getClientSHHKey(this.client.id, keyId).subscribe(
      (res) => {
        this.publicKey = res?.publicKey;
        this.isLoadingSSH = false;
      },
      (err) => {
        this.isLoadingSSH = false;
      }
    );
  }

  closeSSHInfo() {
    this.toggleSSHPublicKey = false;
    this.publicKey = null;
  }

  invoiceConfig(form: NgForm) {
    let data = {
      customInvoiceConfig: { columns: [] },
    };

    let fields = form.form.value;
    Object.entries(fields).forEach(([key, value]) => {
      if (value === true) {
        data.customInvoiceConfig.columns.push(key);
      }
    });

    let body = JSON.stringify(data);

    this.applicationService.updateClient(this.client.id, body).subscribe(
      (response: IClientModel) => {
        this.toastr.success(`Client ${response.name} updated.`);
        this.loadClients(this.customerId);
        this.toggleChangeInvoice = false;
        this.client = null;
      },
      (error) => {
        this.translate.get('errors.errorUpdatingClient').subscribe((text: string) => {
          this.toastr.error(text);
        });
      }
    );
  }
}
